export default class StockSearchItemBase {
    constructor() {

        this.skuGroup = '';
        this.warehouse = '';
        this.skuNumber = '';
        this.skuComposite = '';
        this.skuName = '';
        this.skuDescription = '';
        this.descHeadOne = '';
        this.descHeadTwo = '';
        this.descHeadThree = '';
        this.descHeadFour = '';
        this.descHeadFive = '';
        this.descHeadSix = '';
    }
}
